import get from 'lodash/get'

export const getIsLoadingProducts = (state, id) => get(state, ['products', id, 'loading']);
export const getProductsLoaded = (state, id) => get(state, ['products', id, 'loaded']);
export const getProducts = (state, id) => get(state, ['products', id, 'shopItems']);



// WEBPACK FOOTER //
// ./src/selectors/product.js